import { PermissionCheckFn } from './team-access';
import { COMPANY_SETTINGS_PERMISSIONS } from './company-permissions.config';
import { POS_PERMISSIONS } from './pos-permissions.config';
import { TEAM_ROLE_PERMISSIONS, TEAM_USER_PERMISSIONS } from './team-permissions.config';

/** Techos del plan relevantes para el ítem Configuración del perfil. */
export interface ProfileConfigurationPlanGate {
  readonly moduleConfiguration?: boolean;
  readonly moduleUsers?: boolean;
  readonly rolesAdmin?: boolean;
}

export interface ProfileConfigurationLinkOptions {
  /** En shell POS: preferir `/pos/configuracion` si hay permiso POS. */
  readonly preferPosConfig?: boolean;
}

/**
 * Destino del ítem «Configuración» del menú de perfil según permisos y plan.
 * Soft upsell: si el plan apaga Configuración, el ítem sigue visible → demo in-page.
 */
export function resolveProfileConfigurationLink(
  can?: PermissionCheckFn,
  plan?: ProfileConfigurationPlanGate,
  options?: ProfileConfigurationLinkOptions
): string | null {
  if (options?.preferPosConfig && can) {
    const posIndex = POS_PERMISSIONS.index;
    // Solo quien opera el POS (pos.index). Mesero solo-Mesas no ve Configuración.
    if (can(posIndex.resource, posIndex.action)) {
      return '/pos/configuracion';
    }
    return null;
  }

  if (!can) {
    return '/settings/company';
  }

  const companyShow = COMPANY_SETTINGS_PERMISSIONS.show;
  if (can(companyShow.resource, companyShow.action)) {
    return '/settings/company';
  }

  if (plan?.rolesAdmin !== false) {
    const rolesList = TEAM_ROLE_PERMISSIONS.list;
    if (can(rolesList.resource, rolesList.action)) {
      return '/account/roles';
    }

    const rolesUpdate = TEAM_ROLE_PERMISSIONS.update;
    if (can(rolesUpdate.resource, rolesUpdate.action)) {
      return '/account/roles';
    }
  }

  if (plan?.moduleUsers !== false) {
    const usersList = TEAM_USER_PERMISSIONS.list;
    if (can(usersList.resource, usersList.action)) {
      return '/account/users';
    }
  }

  // Soft upsell / sin match específico: datos de empresa.
  return '/settings/company';
}
